export default __webpack_public_path__ + "static/media/6.1e81ddfc.png";